import { createContext, useCallback, useContext, useMemo, useState } from "react";
import DemoAccessModal from "./demo-access-modal";

const DemoAccessContext = createContext(null);

export function DemoAccessProvider({ children }) {
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [pendingDemo, setPendingDemo] = useState(null);

  const openDemo = useCallback(
    (demoUrl, demoLabel) => {
      if (isUnlocked) {
        window.open(demoUrl, "_blank", "noopener,noreferrer");
        return;
      }

      setPendingDemo({ url: demoUrl, label: demoLabel });
    },
    [isUnlocked]
  );

  const closeModal = useCallback(() => {
    setPendingDemo(null);
  }, []);

  const unlockDemo = useCallback(() => {
    setIsUnlocked(true);

    if (pendingDemo?.url) {
      window.open(pendingDemo.url, "_blank", "noopener,noreferrer");
    }

    setPendingDemo(null);
  }, [pendingDemo]);

  const value = useMemo(
    () => ({ openDemo, isUnlocked }),
    [openDemo, isUnlocked]
  );

  return (
    <DemoAccessContext.Provider value={value}>
      {children}
      <DemoAccessModal
        isOpen={Boolean(pendingDemo)}
        onClose={closeModal}
        demoLabel={pendingDemo?.label ?? ""}
        onUnlock={unlockDemo}
      />
    </DemoAccessContext.Provider>
  );
}

export function useDemoAccess() {
  const context = useContext(DemoAccessContext);
  if (!context) {
    throw new Error("useDemoAccess must be used within DemoAccessProvider");
  }
  return context;
}
